module.exports = __webpack_public_path__ + "img/poster1.c9aeff83.png";